import { useQuery } from "react-query";
import { ReferralApi } from "../../services";
export const useReferralStatus = () => {
    return useQuery("ReferralApi.getStatus", () => ReferralApi.init().getStatus(), { initialData: null });
};
//# sourceMappingURL=useReferralStatus.js.map